import * as Yup from 'yup';

export const tagFormValidationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  activityTypes: Yup.array().of(Yup.string()).min(1, 'Please select at least one activity type'),
  isSessionPeriod: Yup.boolean(),
  // `concat`ing the date schema (rather than returning it) keeps yup 0.32's behaviour:
  // concat clones the incoming schema, so the branch stays a date schema and the value is
  // still cast to a Date before `required` runs.
  validFrom: Yup.mixed().when('isSessionPeriod', {
    is: (isSessionPeriod) => isSessionPeriod === true,
    then: (schema) => schema.concat(Yup.date().required('Valid From is Required'))
  }),
  validTo: Yup.mixed().when('isSessionPeriod', {
    is: (isSessionPeriod) => isSessionPeriod === true,
    then: (schema) => schema.concat(Yup.date().required('Valid To is Required'))
  })
});
